import { PlayerDataType } from 'src/components/admin/playersRow/helpers/makePlayersData';
import styled from 'styled-components';
import DeleteIcon from '../../assets/images/delete.svg';
import { Text } from '../text';
import { ParticipantBalance } from '../participantBalance';

const Wrapper = styled.div`
    display: flex;
    /* width: 110px; */
    height: 128px;
    flex-direction: column;
    margin: 0 32px;
    position: relative;
    align-items: center;

    .playerIcon {
        width: 75px;
    }

    &.disabled {
        opacity: 0.3;
    }

    .name {
        font-size: 20px;
    }

    .wager {
        font-size: 26px;
    }

    .answer {
        font-size: 30px;

        &.wrong {
            color: red;
        }
    }

    .deleteIcon {
        position: absolute;
        top: 0;
        right: 11px;
        cursor: pointer;
    }

`;

type Props = {
    data: PlayerDataType;
    onDelete?: (name: string) => void;
    canDelete?: boolean;
    style?: React.CSSProperties | undefined;
    className?: string | undefined;
    canUpdate?: boolean;
    onUpdate?: (name: string, attributes: Record<string, any>) => Promise<void>;
};

export const Player = ({
    data: { answer, wager, name, isAnswerCorrect, icon, disabled, balance, id },
    onDelete,
    canDelete,
    style,
    className,
    canUpdate,
    onUpdate,
}: Props) => {
    const handleBalanceUpdate = async (newBalance: number) => {
        if (onUpdate) {
            await onUpdate(name, { balance: newBalance });
        }
    };

    const showBalance = balance !== undefined && balance !== '';

    return (
        <Wrapper style={style} className={`${className ? className : ''}${disabled ? ' disabled' : ''}`}>
            <img className="playerIcon" src={icon} alt="" />
            {canDelete ? (
                <img
                    onClick={() => {
                        onDelete?.(name);
                    }}
                    className="deleteIcon"
                    src={DeleteIcon}
                    alt="Delete"
                />
            ) : null}
            <Text className="name">{name}</Text>
            {showBalance ? (
                <ParticipantBalance
                    balance={balance}
                    canUpdate={canUpdate || false}
                    onBalanceUpdate={handleBalanceUpdate}
                />
            ) : null}
            <Text className="wager">{wager}</Text>
            <Text className={`answer${isAnswerCorrect ? '' : ' wrong'}`}>{answer}</Text>
        </Wrapper>
    );
};
